import AttachDocuments from './attach-documents.component.vue';

export { AttachDocuments };
